<div class="row pagination-row">
  <div class="col-md-6 col-ms-6 col-xs-6">
    <div>
      {{'Showing' }}
      <span class="no_rec">{{pageRange}}</span>&nbsp;{{'of'}}
      <span class="no_rec">{{totalOrders}}</span>&nbsp;{{'products'}}
    </div>
  </div>
  <div class="col-md-6 col-ms-6 col-xs-6 padding-align">
    <div class="pagination-align">
      <span class="margin-align">{{ 'Page' }} {{ curPage }}
        {{ 'of' }} {{ numberOfPages }}</span>
      <div class="pagination align-btns">
        <button [disabled]="curPage == 1" class="pagination-btns mr-1" (click)="getCurrentPage('prev')">
          <span class="chevronIconWhite prev">
            < </span>
        </button>
        <button class="pagination-btns" [disabled]="
          curPage >= totalOrders / pageSize ||
          (totalOrders === 0 && pageSize === 0)
        " (click)="getCurrentPage('next')">
          <span class="chevronIconWhite next"> > </span>
        </button>
      </div>
    </div>
  </div>
</div>